export const PARCEL_STATUS_LABELS: Record<string, string> = {
  INBOUND: 'Unterwegs',
  READY_FOR_CONSIGNEE_PICKUP: 'Abholbereit',
  READY_FOR_UPS_PICKUP: 'Aged',
  AWAITS_DRIVER_PICKUP: 'Fahrer erwartet',
  DISPOSSESSIONS: 'Abgeholt',
  UNKNOWN: 'Unbekannt',
  DROP_OFF: 'Drop-off',
  SHIPPER_DROP_OFF: 'Absender-Drop',
  INTERNAL_PROCESSING: 'Intern',
};

export const parcelStatusText = (status: string) => PARCEL_STATUS_LABELS[status] || status;
